import type { ValidationError } from '@wix/form-validator';
import React from 'react';

import { type FieldLayoutComponent } from '../../../../field-layout';
import { isMultilineAddressField } from '../../../../services/multiline-address';
import {
  type FormValues,
  isInputField,
  type OnFieldChange,
  type OnBlur,
  type OnFocus,
  isNestedFormField,
  type Field,
} from '../../types';

import { InputField } from './input-field';
import { NestedFormField } from './nested-form-field';
import { ReadOnlyField } from './read-only-field';
import { SubmitButtonField } from './submit-button-field';

interface FormFieldProps {
  field: Field;
  values: FormValues;
  errors: ValidationError[];
  onFieldChange?: OnFieldChange;
  onBlur?: OnBlur;
  onFocus?: OnFocus;
  FieldLayout: FieldLayoutComponent;
}

export const FormField = ({ field, FieldLayout, ...rest }: FormFieldProps) => {
  if (!isMultilineAddressField(field) && isNestedFormField(field)) {
    return (
      <NestedFormField {...rest} field={field} FieldLayout={FieldLayout} />
    );
  }

  if (isInputField(field)) {
    return <InputField {...rest} field={field} FieldLayout={FieldLayout} />;
  }

  if (field.fieldType === 'SUBMIT_BUTTON') {
    return (
      <SubmitButtonField {...rest} field={field} FieldLayout={FieldLayout} />
    );
  }

  return <ReadOnlyField {...rest} field={field} FieldLayout={FieldLayout} />;
};
